export default {
  nav: {
    app: 'Shop aid',
    logout: 'LOGOUT', telService: 'TELSERVICE',
    onlineService: 'ONLINESERVICE',
    help: 'Help',
    privacy: 'Privacy',
    provision: 'Provision',
  },
  label: {
    loginWelcome: 'Welcome to UNIQLO Tapestry order system',
    login: 'Login',
    account: 'Account',
    pass: 'Password',
    inputAccount: 'Please input shop number',
    inputPass: 'Please input password',
    inputLenAccount: 'Character length between 1 and 20',
    inputLenPass: 'Character length between 3 and 20',
    forgetPass: 'Forget password?',
    contactService: 'Please contact customer service for assistance.',
    copyright: 'Senkoo. All rights reserved.',
    shopMap: 'Shop map',
    shopname: 'Shop name',
    clickHelp: 'Click point then select images',
    floor: 'Floor',
    pointCurrent: 'Selecting',
    pointChoosed: 'Selected',
    pointNone: 'No change',
    pointNotyet: 'To be selected', pointReview: 'Preview',
    pointSave: 'Save',
    pointList: 'Selected point list',
    orderHistory: 'History order list',
    del: 'Delete',
    timeLeft: 'Time left',
    waitOrder: 'Project not start,please mention latest notice',
    day: 'day',
    hour: 'h',
    min: 'min',
    second: 's',
    oldimg: 'Origin image',
    newimg: 'New image',
    chooseTips: 'Please to select new image',
    selectFor: 'Point need image count:',
    selectPlaceholder: 'Image group number/image num',
    selected: 'Selected',
    selectBtn: 'Confirm',
    btnBack: 'Back',
    btnDownPDF: 'Download PDF',
    shopNone: 'Unselected,then no need to produce this time',
    btnDownPointList: 'Down point list',
    btnViewPointReport: 'View point image result'
  },
  table: {
    kind: 'Floor',
    pointid: 'Point',
    location: 'Location',
    material: 'Material',
    size: 'Size(Count)',
    oldimg: 'Before installation',
    count: 'Qty',
    newimg: 'After installation',
    action: 'Operation',
    orderNo: 'Order number',
    orderState: 'Status',
    orderCreatedAt: 'Order time',
    orderCreatedBy: 'Order placer',
    deadline: 'Deadline',
    date:'Date',
    ordernum:'Order batch number'
  },
  msg: {
    confirmLogout: 'Confirm to logout?',
    confirmDelImg: 'Confirm to delete images?',
    confirmDownPoint: 'Confirm to download points?',
    plsChooseImg: "Please select image",
    plsChooseImgCount: "Please select need image count",
    chooseSuccess: 'Select image success'
  }
}